<template>
    <div class="bottom">

        <v-btn
            class="primary basic-info__savechange"
            dark
            @click.stop="dialog = true"
        >
            Rozpustit tým
        </v-btn>

        <v-dialog
                v-model="dialog"
                max-width="400"
        >
            <v-card>
                <v-card-title class="headline">Opravdu rozpustit tým?</v-card-title>

                <v-card-text>
                    Tým bude zrušen a doposud získané body smazány.
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>

                    <v-btn
                        color="secondary"
                        text
                        :disabled="loading"
                        @click="dialog = false"
                    >
                        Zrušit
                    </v-btn>

                    <v-spacer></v-spacer>

                    <v-btn
                        color="primary"
                        dark
                        :loading="loading"
                        @click.prevent="onDisband"
                    >
                        Ano, rozpustit
                    </v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>

</template>

<script>
    import { DISBAND_TEAM_REQUEST } from '../../store/actions/team'

    export default {
        name: 'DisbandTeam',
        data () {
            return {
                dialog: false,
                loading: false,
            }
        },
        methods: {
            async onDisband () {
                try {
                    this.loading = true;
                    await this.$store.dispatch('team/' + DISBAND_TEAM_REQUEST);
                    this.dialog = false;
                    this.$toast.success('Tým byl úspěšně zrušen.');
                } catch (e) {
                    this.$toast.error('Došlo k chybě při zrušení týmu. Zkuste to později.');
                } finally {
                    this.loading = false;
                }
            },
        },
    }
</script>

<style scoped>

</style>
